import { render, staticRenderFns } from "./SpecialityMultiplePickerInput.vue?vue&type=template&id=a02a56d2&scoped=true&"
import script from "./SpecialityMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./SpecialityMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a56d2",
  null
  
)

export default component.exports